import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "onClick", "onMouseDown", "text", "hideLink", "disableLink", "loading", "nestedChildren", "tooltipLabel", "external", "icon", "fullText"];
import emptyFunction from 'react-utils/emptyFunction';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { EPNavigationItemTextColorToken, StyledEPNavigationItemButton } from './EPNavigationStyledButtons';
import { getTarget, useButtonFocusStyles } from '../utils/buttonUtils';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPNavigationItem = ({
  isTopLevel = false,
  navItem
}) => {
  const {
      id,
      onClick = emptyFunction.thatReturns,
      onMouseDown,
      text,
      hideLink,
      disableLink,
      loading,
      nestedChildren,
      tooltipLabel,
      external
    } = navItem,
    domProps = _objectWithoutPropertiesLoose(navItem, _excluded);
  const disabled = Boolean(disableLink || loading);
  const {
    focusRingStyles,
    mergedProps
  } = useButtonFocusStyles({
    disabled,
    domProps,
    onClick,
    onMouseDown
  });
  if (hideLink) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipLabel,
    placement: "right",
    children: /*#__PURE__*/_jsxs(StyledEPNavigationItemButton, Object.assign({
      as: domProps.href ? 'a' : 'button',
      "aria-disabled": disabled,
      "data-nav-item": id,
      "data-test-id": id,
      target: getTarget(external, domProps.target),
      $isDisabled: disabled,
      $isTopLevel: isTopLevel,
      $focusRingStyles: focusRingStyles
    }, mergedProps, domProps, {
      children: [text, loading && /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "inline",
        size: "extra-small",
        margin: "0",
        padding: "0"
      }), !!nestedChildren && /*#__PURE__*/_jsx(RightIcon, {
        color: EPNavigationItemTextColorToken,
        size: "300"
      }), !!domProps.href && /*#__PURE__*/_jsx(ExternalLinkIcon, {
        color: EPNavigationItemTextColorToken,
        size: "300"
      })]
    }))
  });
};
export default EPNavigationItem;